import React from 'react';
import { Link } from 'react-router-dom';
import { statFileUrl } from '../common';

const StatFileLink = ({ fold, fNam, addOpt, nam }) => {
    addOpt = typeof addOpt !== 'undefined' ? addOpt : {};

    let fUrl = statFileUrl(fold, fNam);
    let fLink = null;
    if (fUrl != '') {
        const targ = (addOpt.hasOwnProperty('newTab') && !addOpt['newTab'] ? '' : '_blank');
        const lStyle = (addOpt.hasOwnProperty('lStyle') ? addOpt['lStyle'] : {});
        const dispType = (addOpt.hasOwnProperty('dispType') ? addOpt['dispType'] : 'text');
        let lCont = '';
        if (dispType == 'text') {
            lCont = nam;            
        } else if (dispType == 'im') {
            const lIm = (addOpt.hasOwnProperty('lIm') ? addOpt['lIm'] : '');
            const lFold = (addOpt.hasOwnProperty('lFold') ? addOpt['lFold'] : '');            
            const lImUrl = statFileUrl(lFold, lIm);
            lCont = <img src={ lImUrl } />;            
        }

        fLink = <Link to={{ pathname: fUrl }} target={ targ } style={ lStyle } >
           { lCont }
        </Link>
    }
    return fLink;
}

export default StatFileLink;

